
/**
 * 29x Studio Custom Form - Master Entry Point
 * Modular, performant form handling with event delegation and improved error handling
 */

'use strict';

// Global namespace
var twentyninetimesCustomForm = twentyninetimesCustomForm || {};

/**
 * Main Form Controller
 * Coordinates all form components and handles initialization
 */
twentyninetimesCustomForm.FormController = {
    /**
     * Initialize all form functionality
     */
    initialize: function() {
        // Get all custom forms on the page
        const formulars = Array.from(document.querySelectorAll('.customform-form'));
        if (!formulars.length) return;

        // Initialize event handlers
        if (twentyninetimesCustomForm.FormEventHandlers) {
            twentyninetimesCustomForm.FormEventHandlers.initializeSubmitHandlers();
        }

        // Process each form
        this.initializeForms(formulars);
    },

    /**
     * Initialize individual forms with their specific features
     * @param {Array} formulars - Array of form elements
     */
    initializeForms: function(formulars) {
        formulars.forEach(formular => {
            if (twentyninetimesCustomForm.ConditionalLogic) {
                twentyninetimesCustomForm.ConditionalLogic.initialize(formular);
            }

            // Initialize phone country code functionality if needed
            if (formular.classList.contains('form-has-country-codes')) {
                if (twentyninetimesCustomForm.PhoneCountryCode) {
                    twentyninetimesCustomForm.PhoneCountryCode.initialize(formular);
                }
            }

            // Scroll to response message if present (after form submission)
            const responseElm = formular.querySelector('.customform-response');
            if (responseElm) {
                responseElm.scrollIntoView({ behavior: 'smooth' });
            }
        });
    }
};

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
    twentyninetimesCustomForm.FormController.initialize();
});

